<template>
  <v-layout wrap>
    <v-flex sm12 xs12 md12>
      <v-spacer />
      <div class="text-lg-right">
        <v-btn block outline color="tertiary" @click="newObs"
          ><v-icon left>add</v-icon>Criar Observação</v-btn
        >
      </div>
    </v-flex>
    <v-flex sm12 xs12 md12>
      <div class="text-lg-center" v-if="observations.length <= 0">
        Tome notas sobre esse registro para acompanhar as informações
        importantes.
        <!-- Você pode até fazer uma @mention a um colega de equipe se precisar. . -->
      </div>
      <div v-else>
        <v-card
          color="white"
          dark
          v-for="(item, index) in observations"
          :key="index"
          class="mb-3"
        >
          <v-card-text class="white text--primary pb-0">
            <p class="text--lighten-2 subheading">
              {{ item.created_at | formatarDate }}
            </p>
            <p v-html="item.description"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-layout column>
            <v-card-actions class="pt-0 pb-0">
              <v-btn dark icon>
                <v-icon color="teal">comment</v-icon>
              </v-btn>
              <span class="teal--text caption pr-2"
                >por {{ item.agent_name }}</span
              >
              <v-spacer></v-spacer>

              <v-btn
                icon
                class="mr-3"
                v-if="currentUser && currentUser.id === item.agent_id"
                @click.prevent="edit(item)"
              >
                <v-icon color="grey">edit</v-icon>
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </div>
    </v-flex>
    <div>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialog"
          light
          persistent
          max-width="600px"
          origin="left left"
        >
          <v-card tile>
            <v-toolbar card dark color="success">
              <v-toolbar-title class="white--text">Observação</v-toolbar-title>
              <v-spacer />
              <v-btn icon dark @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-if="id"
                v-model="id"
                readonly
                disabled
                hide-details
              ></v-text-field>
              <v-textarea
                name="observation"
                v-model="description"
                value=""
                placeholder="Comece a digitar para adicionar um observação..."
                hint="Mínimo de 20 caracteres"
              ></v-textarea>
            </v-card-text>
            <v-divider light></v-divider>
            <v-card-actions class="text-xs-right">
              <v-layout align-center justify-end>
                <p v-if="created_at">
                  Criado em {{ created_at | formatarDate }}
                </p>
                <p v-if="updated_at">
                  &nbsp;-&nbsp;Atualizado em {{ updated_at | formatarDate }}
                </p>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="createObservation">
                  Salvar
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="dialog_delete" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline">Apagar Observação?</v-card-title>
                        <v-card-text>Tem certeza que deseja apagar essa observação, essa ação é irreversível.</v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click.prevent="delete(this.observation.id)">Não</v-btn>
                        <v-btn color="green darken-1" flat @click="dialog_delete = false">Sim</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->
      </v-layout>
      <v-snackbar
        v-model="snackbar.value"
        :multi-line="snackbar.mode === 'multi-line'"
        :timeout="snackbar.timeout"
        :top="snackbar.top"
        :color="snackbar.color"
      >
        {{ snackbar.message }}
        <v-btn color="white" flat @click="snackbar.value = false">
          Fechar
        </v-btn>
      </v-snackbar>
    </div>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import { storeObservation } from "../../../services/support/observations";
export default {
  data() {
    return {
      dialog: false,
      dialog_delete: false,
      description: "",
      id: null,
      isNew: true,
      agent_name: "",
      agent_id: null,
      created_at: null,
      updated_at: null,
      customer_id: null,
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
    };
  },
  computed: {
    ...mapState(["currentUser"]),
    ...mapState("cs", ["userCS"]),
    ...mapGetters("cs", ["observations", "observation"]),
    observation_label() {
      return "Observação para " + this.userCS.name;
    },
  },
  mounted() {
    this.getObservationsByUser(this.userCS.id);
    this.customer_id = this.userCS.id;
    this.agent_id = this.currentUser.id;
    this.agent_name = this.currentUser.name;
  },
  methods: {
    ...mapActions("cs", [
      "getObservationsByUser",
      "editObservation",
      "storeObservation",
      "setObservations",
    ]),
    newObs() {
      this.description = "";
      this.id = null;
      this.isNew = true;
      this.agent_name = this.currentUser.name;
      this.agent_id = this.currentUser.id;
      ((this.created_at = null),
        (this.updated_at = null),
        (this.customer_id = this.userCS.id));
      this.dialog = true;
    },
    // delete(observation_id) {
    //     deleteObservation(this.userCS.id, observation_id)
    //         .then(() => {
    //             this.dialog = false
    //             this.showSnackBar('Observação apagada com sucesso!', 'top', 'green')
    //             // alert('Sucesso!')
    //         })
    //         .catch(err => {
    //             this.showSnackBar('Erro ao apagar observação. Contate nosso suporte. ' + err, 'top', 'red')
    //             console.error(err)
    //             // alert('erro ao adicionar usuario')
    //         })
    // },
    edit(observation) {
      this.editObservation(observation);
      this.description = observation.description || "";
      ((this.isNew = false), (this.id = observation.id));
      this.agent_name = observation.agent_name || "";
      this.agent_id = observation.agent_id || "";
      ((this.created_at = observation.created_at || ""),
        (this.updated_at = observation.updated_at || ""));
      this.dialog = true;
    },
    createObservation() {
      // console.log('currentUser: ', this.currentUser)
      // console.log('userCS.id: ', this.userCS.id)
      if (this.currentUser && this.userCS.id) {
        const new_observation = {
          id: this.id,
          customer_id: this.customer_id,
          description: this.description,
          agent_name: this.agent_name,
          agent_id: this.agent_id,
        };
        // console.log('obs: ', new_observation)
        storeObservation(new_observation, this.isNew)
          .then(() => {
            // console.log('obs: ', obs)
            // const new_obs = this.observations.push(obs.data())
            // this.setObservations(new_obs)
            this.dialog = false;
            this.showSnackBar("Observação criada com sucesso!", "top", "green");
            // alert('Sucesso!')
          })
          .catch((err) => {
            this.showSnackBar(
              "Erro ao criar observação. Contate nosso suporte. " + err,
              "top",
              "red",
            );
            console.error(err);
            // alert('erro ao adicionar usuario')
          });
      } else {
        alert("Erro: usuário não informado");
      }
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
  },
  filters: {
    formatarDate(value) {
      if (!value) return "";
      return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>
<style scoped>
.v-input__slot {
  border: 0px;
}
</style>
